var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 351,
    viewBox: "0 0 420 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-119.447 453.773C-108.525 470.497 -95.7209 486.351 -81.0358 501.036C-66.3507 515.721 -50.4966 528.525 -33.7731 539.447L-119.447 453.773Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.770584 558.059L-138.059 420.771C-142.211 412.14 -145.916 403.348 -149.175 394.43L25.5704 569.175C16.6521 565.917 7.86021 562.211 -0.770584 558.059Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8162 576.031C53.4743 577.902 60.1854 579.534 66.9362 580.926L-160.926 353.064C-159.534 359.815 -157.902 366.526 -156.031 373.184L46.8162 576.031Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-163.98 335.62L84.3803 583.98C90.0935 584.804 95.8264 585.459 101.571 585.946L-165.946 318.429C-165.459 324.174 -164.804 329.907 -163.98 335.62Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-166.843 303.142L116.858 586.843C121.965 587.009 127.076 587.044 132.185 586.945L-166.945 287.815C-167.044 292.924 -167.009 298.035 -166.843 303.142Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-166.356 274.014L145.986 586.356C150.649 586.048 155.306 585.629 159.953 585.099L-165.099 260.047C-165.629 264.694 -166.048 269.351 -166.356 274.014Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-163.375 247.38L172.62 583.375C176.93 582.693 181.227 581.915 185.509 581.04L-161.04 234.491C-161.915 238.773 -162.693 243.07 -163.375 247.38Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-158.39 222.75L197.25 578.39C201.264 577.397 205.261 576.319 209.238 575.154L-155.154 210.762C-156.319 214.739 -157.397 218.736 -158.39 222.75Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.714 199.812L220.188 571.714C223.945 570.452 227.68 569.112 231.393 567.694L-147.694 188.607C-149.112 192.32 -150.452 196.056 -151.714 199.812Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-143.555 178.356L241.645 563.555C245.17 562.053 248.671 560.48 252.148 558.834L-138.834 167.853C-140.48 171.329 -142.053 174.83 -143.555 178.356Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-134.061 158.235L261.765 554.061C265.078 552.34 268.365 550.551 271.624 548.695L-128.695 148.376C-130.551 151.635 -132.34 154.922 -134.061 158.235Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-123.335 139.346L280.654 543.335C283.769 541.41 286.855 539.421 289.912 537.368L-117.368 130.089C-119.421 133.145 -121.41 136.231 -123.335 139.346Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.454 121.612L298.388 531.454C301.314 529.335 304.21 527.156 307.074 524.915L-104.915 112.926C-107.156 115.79 -109.335 118.686 -111.454 121.612Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-98.4723 104.979L315.021 518.472C317.765 516.167 320.477 513.804 323.156 511.383L-91.3826 96.8443C-93.804 99.5226 -96.1672 102.235 -98.4723 104.979Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.4265 89.41L330.59 504.427C331.746 503.308 332.894 502.177 334.036 501.036C335.437 499.635 336.821 498.223 338.188 496.8L-76.8003 81.8117C-78.2226 83.1787 -79.6346 84.5629 -81.0358 85.9642C-82.1774 87.1058 -83.3077 88.2544 -84.4265 89.41Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.3395 74.8822L345.118 489.34C347.53 486.652 349.883 483.93 352.179 481.176L-61.1763 67.821C-63.9301 70.1165 -66.6517 72.4702 -69.3395 74.8822Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.2018 61.4052L358.595 473.202C360.826 470.328 362.995 467.423 365.105 464.487L-44.4871 54.8955C-47.4227 57.0046 -50.3282 59.1745 -53.2018 61.4052Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.982 49.0102L370.99 455.982C373.033 452.915 375.011 449.819 376.927 446.694L-26.6939 43.0735C-29.8186 44.9886 -32.9153 46.9675 -35.982 49.0102Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.6338 37.7433L382.257 437.634C384.102 434.364 385.88 431.066 387.589 427.742L-7.74207 32.4106C-11.0658 34.1205 -14.3637 35.898 -17.6338 37.7433Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9073 27.6696L392.33 418.093C393.965 414.605 395.527 411.091 397.017 407.555L12.4454 22.9833C8.90872 24.4729 5.39523 26.0351 1.9073 27.6696Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7315 18.8789L401.121 397.269C402.526 393.543 403.853 389.794 405.102 386.025L33.9751 14.8982C30.2061 16.1467 26.4574 17.4736 22.7315 18.8789Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9639 11.4966L408.503 375.036C409.654 371.044 410.718 367.032 411.696 363.004L56.9965 8.30445C52.9679 9.28218 48.9561 10.3462 44.9639 11.4966Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7818 5.69941L414.301 351.218C415.159 346.919 415.92 342.604 416.584 338.277L81.7226 3.4158C77.3958 4.08011 73.0811 4.84132 68.7818 5.69941Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4425 1.74541L418.255 325.557C418.765 320.889 419.163 316.211 419.449 311.528L108.472 0.550755C103.789 0.837203 99.1107 1.23544 94.4425 1.74541Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.341 0.0292748L419.971 297.659C420.043 292.522 419.981 287.383 419.786 282.249L137.751 0.214388C132.617 0.0186579 127.478 -0.0430603 122.341 0.0292748Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.13 1.20323L418.797 266.87C418.273 261.085 417.578 255.312 416.712 249.56L170.44 3.2884C164.688 2.42222 158.915 1.72718 153.13 1.20323Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.028 6.48597L413.514 231.972C412.058 225.15 410.357 218.37 408.411 211.645L208.355 11.5887C201.63 9.64269 194.85 7.9418 188.028 6.48597Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.895 18.7383L401.262 190.105C397.837 180.987 393.942 172.005 389.578 163.197L256.803 30.4215C247.995 26.0576 239.013 22.1633 229.895 18.7383Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.431 50.6595L369.341 128.569C359.119 113.555 347.351 99.2792 334.036 85.9642C320.721 72.6492 306.445 60.881 291.431 50.6595Z",
    fill: "url(#paint28_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: -79.1123,
    y1: 85.1108,
    x2: 338.691,
    y2: 502.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.341674fb1a49337acdf0e8162bfc163b.svg";
export { ForwardRef as ReactComponent };